export default __webpack_public_path__ + "static/media/mac-mfa-code.8e9fc86a.svg";